<template>
    <div class="subtitle d-flex justify-content-center align-items-center background"
         :style="{'background-image':`url('${imageUrl}')`}"></div>
</template>

<script>
export default {
    name: 'SubHeader',
    data() {
        return { imageUrl: '../../assets/images/faq/qa.png' };
    },
    methods: {

    },
    watch: {
        '$route.params.index': {
            handler(index) {
                switch (index) {
                    case '1':
                        this.imageUrl = require('@/assets/images/faq/qa1.png');
                        break;
                    case '2':
                        this.imageUrl = require('@/assets/images/faq/qa2.png');
                        break;
                    case '3':
                        this.imageUrl = require('@/assets/images/faq/qa3.jpg');
                        break;
                    default:
                        this.imageUrl = require('@/assets/images/faq/qa.png');
                        break;
                }
            },
            deep: true,
            immediate: true
        },
    }
};
</script>

<style lang="scss" scoped>
.subtitle {
    background-color: #f5f5f5;
    font-size: 1.25rem;
    height: 100px;
    @media (max-width: 768px) {
        & {
            height: 19vw;
            min-height: 80px;
        }
    }
}
.background {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}
</style>
